import React, { useState, useEffect } from "react";

export const ResultTable = (props) => {
  const [hasSummary, setHasSummary] = useState(false);

  useEffect(() => {
    const dataString = JSON.stringify(props.data);
    console.log(dataString)
    setHasSummary(dataString?.length > 2);
  }, [props.data]);

  return (
    props.data ? (
      <div style={{paddingBottom: "10px"}}>
        {hasSummary ? (
          <>
          <h4 style={{paddingTop: "30px"}}>Testing Information</h4>
            <div>
              <b>Reported Potency</b>: {props.data["Reported Potency"]}
            </div>
            <table
              id="resultSummary"
              style={{
                tableLayout: "fixed",
                width: "100%",
                borderCollapse: "collapse",
              }}
            >
              <tbody>
                <tr>
                  <td style={{ padding: "5px" }}>Potency</td>
                  <td
                    id="potency"
                    style={
                      props.data.potency
                        ? { color: "green" }
                        : { color: "yellowgreen" }
                    }
                  >
                    {props.data.potency || "NA"}
                  </td>
                  <td style={{ padding: "5px" }}>Salmonella</td>
                  <td
                    id="salmonella"
                    style={
                      props.data.salmonella
                        ? { color: "green" }
                        : { color: "yellowgreen" }
                    }
                  >
                    {props.data.salmonella || "NA"}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: "5px" }}>E. Coli</td>
                  <td
                    id="ecoli"
                    style={
                      props.data.ecoli
                        ? { color: "green" }
                        : { color: "yellowgreen" }
                    }
                  >
                    {props.data.ecoli || "NA"}
                  </td>
                  <td style={{ padding: "5px" }}>Mycotoxin</td>
                  <td
                    id="mycotoxin"
                    style={
                      props.data.mycotoxin
                        ? { color: "green" }
                        : { color: "yellowgreen" }
                    }
                  >
                    {props.data.mycotoxin || "NA"}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: "5px" }}>Aspergillus</td>
                  <td
                    id="aspergillus"
                    style={
                      props.data.aspergillus
                        ? { color: "green" }
                        : { color: "yellowgreen" }
                    }
                  >
                    {props.data.aspergillus || "NA"}
                  </td>
                  <td style={{ padding: "5px" }}>Pesticides</td>
                  <td
                    id="pesticides"
                    style={
                      props.data.pesticides
                        ? { color: "green" }
                        : { color: "yellowgreen" }
                    }
                  >
                    {props.data.pesticides || "NA"}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: "5px" }}>Heavy Metals</td>
                  <td
                    id="heavyMetals"
                    style={
                      props.data.heavyMetals
                        ? { color: "green" }
                        : { color: "yellowgreen" }
                    }
                  >
                    {props.data.heavyMetals || "NA"}
                  </td>
                  <td style={{ padding: "5px" }}>Residual Solvents</td>
                  <td
                    id="residualSolvents"
                    style={
                      props.data.residualSolvents
                        ? { color: "green" }
                        : { color: "yellowgreen" }
                    }
                  >
                    {props.data.residualSolvents || "NA"}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: "5px" }}>Herbicides</td>
                  <td
                    id="herbicides"
                    style={
                      props.data.herbicides
                        ? { color: "green" }
                        : { color: "yellowgreen" }
                    }
                  >
                    {props.data.herbicides || "NA"}
                  </td>
                </tr>
              </tbody>
            </table>
          </>
        ) : (
          <div id="noSummary">
            No Summary Available. Please see full results below.
          </div>
        )}
      </div>
    ) : ""
  );
};
